
import { Badge } from "antd";

const TagLabel = (props) => {
   const { tag } = props;

  return (
     <div
         style={{
            display: "inline-block",
            padding: "3px 13px",
            borderRadius: "30px",
            border: `1px solid ${tag?.outline}`,
            backgroundColor: tag?.bgColor,
         }}
      >
            {tag?.icon ? (
               <span style={{ display: "flex", alignItems: "center" }}>
                  {tag?.icon && <img src={tag?.icon} alt="icon" style={{ width: '15px'}}/>}
                  <span style={{ color: tag?.colorTag, marginLeft: "5px" }}>{tag?.name}</span>
               </span>
            ) : (
               <Badge
                  color={tag?.colorTag}
                  text={<span style={{ color: tag?.colorTag }}>{tag?.name}</span>}
               />
            )}
     </div>
  );
};

export default TagLabel;